/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from "react";
import { Card, Form, Button, Modal, InputGroup } from "react-bootstrap";
import { TweetyWidget } from "../../../../widgets/tweety-widget-react-main";
import moment from "moment-timezone";

export interface IReportModalProps {
  showModal?: boolean;
  createStudentLabel?: string;
  onAcknowledgement?(
    startDate: string,
    endDate: string,
  ): void;
  onDeny?(): void;
  presentationLists?: any;
  fields: any;
  layout?: any;
  textInputValue?: string;
}

const is = require("is_js");
export const ReportModal = ({
  showModal,
  createStudentLabel,
  onDeny,
  onAcknowledgement,
  presentationLists,
  fields,
  layout,
}: IReportModalProps) => {
  const [selectedPresentation, setSelectedPresentation] = useState("");
  const [startDateSelected, setStartDateSelected] = useState("");
  const [endDateSelected, setEndDateSelected] = useState("");
  const [show, setShow] = useState(showModal);
console.log("sdfgsdfgdsfsf",fields,layout)
  const handlePresentationChange = (value: any, payload: any) => {
    console.log("presentation list in invite user", value,payload, );
    if (value === "startDate") {
      setStartDateSelected(payload);
    }
    if (value === "endDate") {
      setEndDateSelected(payload);
    }
    
  };



  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };
  const _onFormSubmit = (data:any) => {
    console.log("DATA!@#",data)
    console.log("startDateSelected, endDateSelected",startDateSelected, endDateSelected)
    let formattedStartDate: any, formattedEndDate: any;
    if (data?.startdate) {
      const momentDate = moment(data?.startdate).startOf("day");
      formattedStartDate = momentDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    }
    if (data?.enddate) {
      const momentDate = moment(data?.enddate).endOf("day");
      formattedEndDate = momentDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    }
    console.log("selectedPresentation", formattedStartDate, formattedEndDate)
    if (onAcknowledgement) {
      onAcknowledgement(
        formattedStartDate,
        formattedEndDate
      );
    }
    setShow(false);
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header className="border-0">
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Header className="text-center text-md-center border-0 mb-0 mt-md-0">
            
            <h4>{createStudentLabel}</h4>
          </Card.Header>
          <Card.Body>
            <TweetyWidget
              labelColor={"#000000"}
              onSelectChange={handlePresentationChange}
              fields={fields}
              layout={layout}
              submitButtonLabel={"Download"}
              // renderSubmitButton={()=><><div className="mt-3 d-flex justify-content-center"><Button onClick={_onFormSubmit}>Download</Button></div></>}
              onFormSubmit={_onFormSubmit}
            />
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

ReportModal.defaultProps = {
  showModal: false,
  createStudentLabel: "Download Report",
};
